/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Venue_FilterInputs */

const cs_settings_teams_venue_filter = /** @type {(inputs: Settings_Teams_Venue_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočka`)
};

const en_settings_teams_venue_filter = /** @type {(inputs: Settings_Teams_Venue_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch`)
};

/**
* | output |
* | --- |
* | "Branch" |
*
* @param {Settings_Teams_Venue_FilterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_venue_filter = /** @type {((inputs?: Settings_Teams_Venue_FilterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Venue_FilterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_venue_filter(inputs)
	return cs_settings_teams_venue_filter(inputs)
});